import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { ModalFooterComponent } from '../modal-footer/modal-footer.component';
import { TranslatePipe } from '@core/pipes';
import { AsyncPipe } from '@angular/common';
import { DialogRef } from '@angular/cdk/dialog';
import { Substitutions } from '@selfcare/cms';
import { Store } from '@ngrx/store';
import { userFeature } from '@state';
import { ButtonComponent } from '../button/button.component';
import { SvgComponent } from '../svg/svg.component';

@Component({
  selector: 'sc-activate-simcard-modal',
  imports: [
    ModalComponent,
    ButtonComponent,
    ModalFooterComponent,
    SvgComponent,
    TranslatePipe,
    AsyncPipe,
  ],
  templateUrl: './activate-simcard-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivateSimcardModalComponent {
  userFirstName = this.store.selectSignal(userFeature.selectUserFirstName);
  Substitutions = Substitutions;

  constructor(
    private readonly dialogRef: DialogRef<boolean>,
    private readonly store: Store,
  ) {}

  public close(approved: boolean) {
    this.dialogRef.close(approved);
  }
}
